import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Layout from "./components/layout/Layout";
import * as ROUTES from "./constants/routes";
import Loading from "../src/components/Loading";

const Home = lazy(() => import("./pages/Home"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Features = lazy(() => import("./pages/Features"));
const Plans = lazy(() => import("./pages/Plans"));
const Tutorials = lazy(() => import("./pages/Tutorials"));
const Downloads = lazy(() => import("./pages/Downloads"));
const Reviews = lazy(() => import("./pages/Reviews"));
const FAQ = lazy(() => import("./pages/FAQ"));
const NotFound = lazy(() => import("./pages/NotFound"));

function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div>
            <Loading />
          </div>
        }
      >
        <Layout>
          <Routes>
            <Route path={ROUTES.HOME} element={<Home />} exact />
            <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />
            <Route path={ROUTES.FEATURES} element={<Features />} />
            <Route path={ROUTES.PLANS} element={<Plans />} />
            <Route path={ROUTES.TUTORIALS} element={<Tutorials />} />
            <Route path={ROUTES.DOWNLOAD} element={<Downloads />} />
            <Route path={ROUTES.REVIEWS} element={<Reviews />} />
            <Route path={ROUTES.FAQ} element={<FAQ />} />
            <Route path={ROUTES.NOTFOUND} element={<NotFound />} />
          </Routes>
        </Layout>
      </Suspense>
    </Router>
  );
}

export default App;
